import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { ClientService } from '../../services/client.service';
import { RecordService } from '../../services/record.service';
import { Client } from '../../shared/models/client.model';
import { Record } from '../../shared/models/record.model';
import { ToastComponent } from '../../shared/toast/toast.component';
import { ee } from '../../shared/constants';
import { removeTooltipElement } from '../../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-record-details',
  templateUrl: './record-details.component.html',
  styleUrls: ['./record-details.component.scss'],
  standalone: false
})
export class RecordDetailsComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private clientService = inject(ClientService);
  private recordService = inject(RecordService);
  toast = inject(ToastComponent);
  private route = inject(ActivatedRoute);
  private router = inject(Router);


  isLoading = {
    record: true
  };
  id = '';
  record: Record;
  clients: Client[] = [];
  currentContent = 'record';
  menuItems = [
    { name: 'Record info', link: 'record', icon: 'list' },
  ];

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.id = this.route.snapshot.paramMap.get('id');
    ee.on('changeContent', (data: string) => this.currentContent = data);
    ee.on('getRecord', () => this.getRecord(this.id));
    this.getRecord(this.id);
    this.getClients();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    ee.off('getRecord', () => {});
    removeTooltipElement();
  }

  getRecord(id: string): void {
    this.isLoading.record = true;
    this.recordService.get(id)
      .pipe(finalize(() => this.isLoading.record = false))
      .subscribe({
        next: res => this.record = res,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  getClients(): void {
    this.clientService.search({ active: '1' })
      .subscribe({
        next: res => this.clients = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
